import script from "./BusinessUnitsWidget.vue?vue&type=script&setup=true&lang=js"
export * from "./BusinessUnitsWidget.vue?vue&type=script&setup=true&lang=js"

import "./BusinessUnitsWidget.vue?vue&type=style&index=0&id=2205c90b&lang=scss"

const __exports__ = script;

export default __exports__